/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-04-01 11:51:34
 * @LastEditTime: 2025-04-01 11:53:40
 * @LastEditors: ywj@originqc.com
 */
import React from "react";
import orderPic from './imgs/order.png';
import './index.scss';

interface IProps { 
  startText:string,
  endText: string,
  width?:number
}
const ProcessTips: React.FC<IProps> = (props) => {
  const { startText, endText,width=235 } = props;
  return <div className="process-tips" style={{ width: width }}>
     <img src={orderPic} alt="订单" />
              <div className="img-text">
      <span>{ startText}</span>
      <span>{ endText}</span>
              </div>
  </div>;
}

export default ProcessTips;
